import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { useAuthContext } from "../../../AuthContextWrapper";
import { RadioAndResponseForm } from "../shared/RadioAndResponseForm";
import { Estate } from "models/Estate";
import { OUTCOMES } from "../../../constants";
import { State } from "models/Geography";

export enum Outcomes {
  yes = "Yes",
  no = "No",
  notSure = "I'm not sure",
}

export const SimpleProbateScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { flow, activeEstate, setActiveEstate, states } =
    useAuthContext()
  const { screenName } = useParams();
  const currentScreen = flow?.getCurrentFlowScreen(screenName);

  const handleComplete = async (
    valueBelowThreshold: string,
    skip?: boolean
  ): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    // const estate = activeEstate ? Estate.from(activeEstate) : new Estate();
    const estate = activeEstate || new Estate();
    estate.valueBelowThreshold = valueBelowThreshold;

    try {
      await estate.saveEstate();
      setActiveEstate(estate);
    } catch (error) {
      throw new Error("could not save data");
    }

    flow?.navigateToNext(currentScreen, OUTCOMES.complete, navigate, {
      replace: skip,
    });
    return true;
  };

  const state = states?.filter(
    (state: State) => state.id === activeEstate?.stateId
  )[0];

  const stateSimpleProbateThreshold = state?.content.valueThreshold;
  const stateName = state?.name;

  if (!stateName || stateSimpleProbateThreshold === 0) {
    // skip forward = state or state threshold is not know
    handleComplete(Outcomes.notSure, true);
  }

  return currentScreen ? (
    <FlowScreenWrapper
      title={`Let’s see if the estate qualifies for simple probate. Are there more than $${stateSimpleProbateThreshold?.toLocaleString(
        "en-US"
      )} of assets in the estate?`}
      subTitle={`In ${stateName}, if the value of an estate is less than $${stateSimpleProbateThreshold?.toLocaleString(
        "en-US"
      )}, then it qualifies for a simpler, faster, and less complex probate process.`}
    >
      <RadioAndResponseForm
        initAnswer={activeEstate?.valueBelowThreshold || undefined}
        answerLabel="an answer"
        errorText="Please select an option to continue"
        options={[
          { value: Outcomes.yes },
          { value: Outcomes.no },
          { value: Outcomes.notSure },
        ]}
        onComplete={async (answer: string): Promise<boolean> => {
          return handleComplete(answer);
        }}
        onBack={() => navigate(-1)}
      />
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
